// src/components/ProductTable.js
import React from 'react';
import { Table, Button, Space, Tooltip } from 'antd';
import { FaSort, FaSortUp, FaSortDown, FaEdit } from 'react-icons/fa';

const ProductTable = ({ products, onShowDetails, onSort, sortField, sortOrder, onEditRack }) => {
    const isLoggedIn = !!localStorage.getItem('userToken');
    const renderSortIcon = (field) => {
        if (sortField !== field) return <FaSort />;
        return sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />;
    };

    const handleSort = (field) => {
        const newOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
        onSort(field, newOrder);
    };

    const columns = [
        {
            title: <span onClick={() => handleSort('item_id')} style={{ cursor: 'pointer' }}>ID {renderSortIcon('item_id')}</span>,
            dataIndex: 'item_id',
            key: 'item_id',
        },
        {
            title: <span onClick={() => handleSort('item_title')} style={{ cursor: 'pointer' }}>Title {renderSortIcon('item_title')}</span>,
            dataIndex: 'item_title',
            key: 'item_title',
        },
        {
            title: <span onClick={() => handleSort('unit_price')} style={{ cursor: 'pointer' }}>Price {renderSortIcon('unit_price')}</span>,
            dataIndex: 'unit_price',
            key: 'unit_price',
            render: price => price ? price.toLocaleString('en-US', {style: 'currency', currency: 'LKR'}) : ''
        },
        {
            title: <span onClick={() => handleSort('isbn')} style={{ cursor: 'pointer' }}>ISBN {renderSortIcon('isbn')}</span>,
            dataIndex: 'isbn',
            key: 'isbn',
        },
        {
            title: <span onClick={() => handleSort('ean13')} style={{ cursor: 'pointer' }}>EAN13 {renderSortIcon('ean13')}</span>,
            dataIndex: 'ean13',
            key: 'ean13',
        },
        {
            title: <span onClick={() => handleSort('mtanufacture')} style={{ cursor: 'pointer' }}>Publisher {renderSortIcon('mtanufacture')}</span>,
            dataIndex: 'mtanufacture',
            key: 'mtanufacture',
        },
        {
            title: <span onClick={() => handleSort('authors')} style={{ cursor: 'pointer' }}>Authors {renderSortIcon('authors')}</span>,
            dataIndex: 'authors',
            key: 'authors',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" onClick={() => onShowDetails(record)}>View</Button>
                    {isLoggedIn && (
                        <Tooltip title="Edit Rack">
                            <Button 
                                icon={<FaEdit />} 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onEditRack(record);
                                }}
                            />
                        </Tooltip>
                    )}
                </Space>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={products}
            rowKey="item_id"
            pagination={false}
            size="middle"
        />
    );
};

export default ProductTable;
